module.exports = __webpack_public_path__ + "img/M958.53905e78.jpg";